/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import LivestreamingRoomView from './livestreamingRoom.view';
import {
  selectLivestreamingRoom,
  getMeetingByLocationAsync,
} from './livestreamingRoom.slice';
import { getProfileAsync, selectAuth } from '../auth/auth.slice';
import { getToken } from '../../helper/localStorage';
import { actions as appActions } from '../app/app.slice';

export interface ILivestreamingRoomContainer {}

const LivestreamingRoomContainer: React.FC<ILivestreamingRoomContainer> = ({}: ILivestreamingRoomContainer) => {
  const dispatch = useAppDispatch();
  const livestreamingRoom = useAppSelector(selectLivestreamingRoom);
  const auth = useAppSelector(selectAuth);

  const history = useHistory();
  const [roomName, setRoomName] = useState<string>('');
  const [roomTitle, setRoomTitle] = useState<string>('');
  const [viewingUrl, setViewingUrl] = useState<string>('');

  useEffect(() => {
    const token = getToken();
    if (token) {
      dispatch(getProfileAsync(null));
    }
    const pathnameArray = history.location.pathname.split('/');
    const room =
      pathnameArray.length > 0 ? pathnameArray[pathnameArray.length - 1] : '';
    dispatch(getMeetingByLocationAsync(room));
    setRoomName(room);
  }, [dispatch, history.location.pathname]);

  useEffect(() => {
    setRoomTitle(livestreamingRoom.roomName);
    setViewingUrl(livestreamingRoom.viewingUrl);
  }, [livestreamingRoom]);

  useEffect(() => {
    dispatch(appActions.setLocationCode('10123'));
  }, []);

  const _backToHomeButtonOnClick = () => {
    history.push('/');
  };
  return (
    <LivestreamingRoomView
      roomName={roomName}
      roomTitle={roomTitle}
      viewingUrl={viewingUrl}
      user={auth?.user}
      backToHomeButtonOnClick={_backToHomeButtonOnClick}
    />
  );
};

export default memo(LivestreamingRoomContainer);
